import { MaterialView, RoomEquipment } from '@elio/emanager-front/material/model';
import { AbstractFilterOption, SingleFilterOption } from '@elio/emanager-front/shared/models';
import { createSingleFilterCustomOption } from './filter.utils';

export const hasNoMaterialFilter = <T extends { materials: MaterialView[]; roomEquipment?: RoomEquipment }>(
  label: string
): SingleFilterOption<T> =>
  createSingleFilterCustomOption({
    translationKey: label,
    filterFunction: (view: T) => view.materials.length === 0,
    isDefault: false,
  });

export const hasBoxFilter = <T extends { materials: MaterialView[] }>(label: string): AbstractFilterOption<T> =>
  createSingleFilterCustomOption({
    translationKey: label,
    filterFunction: (view: T) =>
      !!view.materials.find((material) => material.type === 'BOX_ANDROID' && material.assignment === 'RESIDENT_BOX'),
    isDefault: false,
  });

export const hasTabFilter = <T extends { materials: MaterialView[] }>(label: string): AbstractFilterOption<T> =>
  createSingleFilterCustomOption({
    translationKey: label,
    filterFunction: (view: T) => {
      return !!view.materials.find(
        (material) => material.type === 'TAB_ANDROID' && material.assignment === 'RESIDENT_TAB'
      );
    },
    isDefault: false,
  });

export const hasBoxAndTabFilter = <T extends { materials: MaterialView[] }>(label: string): AbstractFilterOption<T> =>
  createSingleFilterCustomOption({
    translationKey: label,
    filterFunction: (view: T) =>
      !!view.materials.find((material) => material.type === 'BOX_ANDROID' && material.assignment === 'RESIDENT_BOX') &&
      !!view.materials.find((material) => material.type === 'TAB_ANDROID' && material.assignment === 'RESIDENT_TAB'),
    isDefault: false,
  });

export const isLinkToKioskFilter = <T extends { materials: MaterialView[] }>(label: string): AbstractFilterOption<T> =>
  createSingleFilterCustomOption({
    translationKey: label,
    filterFunction: (view: T) => !!view.materials.find((material) => material.assignment === 'KIOSK'),
    isDefault: false,
  });
